import React from 'react';
import {createRoot} from 'react-dom/client';

import Root from './Root';

const root = createRoot(document.getElementById('app'));
root.render(<Root/>);

if (import.meta.hot) {
    // this is necessary for HMR, the only thing we need for the whole app which is nice
    import.meta.hot.accept();
}
